<template>
    <div class="row d-flex align-items-center pt-1">
        <p
            v-if="preorderMention"
            class="col-12 mb-sm-0"
            v-html="preorderMention"
        />
        <div class="col-12 col-sm-auto text-center" style="flex-grow: 1">
            <ob1-boutons
                class="d-block mx-auto w-100"
                :is-button="!!dataTarget"
                :data-toggle="dataTarget ? 'modal' : null"
                :data-target="dataTarget"
                :is-primary="true"
                :label="label"
                :is-disabled="isDisabled"
                :data-oevent-category="dataTarget ? 'popin_poursuivre_votre_commande' : 'fiche_produit'"
                :data-oevent-action="label"
                :data-oevent-label="href"
                :href="href"
            />
        </div>
        <div class="col-12 col-sm-auto py-1" style="flex-grow: 100">
            <availability-mention
                :available="availableOnline"
                :label="availableOnline ? 'Disponible en ligne' : 'Indisponible en ligne'"
            />
            <availability-mention
                :available="availableEresa"
                :label="availableEresa ? 'Disponible en Click & Collect' : 'Indisponible en Click & Collect'"
            />
        </div>
    </div>
</template>

<script>
import AvailabilityMention from "./AvailabilityMention.vue";

export default {
    name: "MobileDetailsCtaAndAvailabilityMentions",
    components: {AvailabilityMention},
    props: {
        availableOnline: {
            type: Boolean,
            required: true
        },
        availableEresa: {
            type: Boolean,
            required: true
        },
        preorderMention: {
            type: String,
            required: false,
            default: null
        },
        label: {
          type: String,
          required: true
        },
        dataTarget: {
            type: String,
            required: false,
            default: null
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        href: {
            type: String,
            required: false,
            default: null
        }
    }
}
</script>
